/**
 * ============================================================================
 * Homepage Section Registry (MVC View Registry)
 * ============================================================================
 *
 * Purpose: Map below-fold section types → components.
 * Static imports (not next/dynamic) so experimental.inlineCss emits <style>
 * instead of render-blocking / preload CSS chunk requests for each section.
 * Same SSR markup for SEO; progressive JS chunking is traded for fewer
 * critical-path CSS network requests (Lighthouse render-blocking audit).
 * ============================================================================
 */

"use client";

import { memo } from "react";
import ProgramBannerBase from "@/components/Homepage/ProgramBanner/ProgramBanner";
import NSATBannerBase from "@/components/molecules/NsatBanner/NsatBanner";
import AccreditationBase from "@/components/Homepage/Accreditation/Accreditation";
import WhyAmityBase from "@/components/Homepage/WhyAmity/WhyAmity";
import ProgramSelectorBannerBase from "@/components/atoms/ProgramSelectorBanner/ProgramSelectorBanner";
import MidBannerSectionBase from "@/components/atoms/Midbannersection/Midbannersection";
import BrandsLogoMbaBase from "@/components/atoms/BrandLogosMba/BrandLogosMba";
import CareerImpactMbaBase from "@/components/sections/CareerImpactMba/CareerImpactMba";
import Reviews2Base from "@/components/HomePageRevamp/Reviews2/Reviews2";
import BeyondScreenCarouselComponentMobileHomeNewBase from "@/components/atoms/BeyondScreenCarouselComponentMobileHomeNew/BeyondScreenCarouselComponentMobileHomeNew";
import BeyondScreenCarouselComponentHomeNewBase from "@/components/atoms/BeyondScreenCarouselComponentHomeNew/BeyondScreenCarouselComponentHomeNew";
import BlogsHomeNewBase from "@/components/atoms/BlogsHomeNew/BlogsHomeNew";
import FaqSectionHomeBase from "@/revamp/sections/HomeNewFaq/FaqSectionHome";
import EverythingAnsweredBase from "@/features/everything-answered";

export const ProgramBanner = memo(ProgramBannerBase);
export const NSATBanner = memo(NSATBannerBase);
export const Accreditation = memo(AccreditationBase);
export const WhyAmity = memo(WhyAmityBase);
export const ProgramSelectorBanner = memo(ProgramSelectorBannerBase);
export const MidBannerSection = memo(MidBannerSectionBase);
export const BrandsLogoMba = memo(BrandsLogoMbaBase);
export const CareerImpactMba = memo(CareerImpactMbaBase);
export const Reviews2 = memo(Reviews2Base);
export const BeyondScreenCarouselComponentMobileHomeNew = memo(
  BeyondScreenCarouselComponentMobileHomeNewBase,
);
export const BeyondScreenCarouselComponentHomeNew = memo(
  BeyondScreenCarouselComponentHomeNewBase,
);
export const BlogsHomeNew = memo(BlogsHomeNewBase);
export const FaqSectionHome = memo(FaqSectionHomeBase);
export const EverythingAnswered = memo(EverythingAnsweredBase);

export const HOME_LAZY_SECTION_MAP = {
  ProgramBanner,
  NSATTEST: NSATBanner,
  Accreditation,
  WhyAmity,
  ProgramSelectorBanner,
  MidBannerSection,
  BrandsLogoMba,
  CareerImpactMba,
  Reviews2,
  BeyondScreenCarouselComponentMobileHomeNew,
  BeyondScreenCarouselComponentHomeNew,
  BlogsHomeNew,
  FaqSectionHome,
  EverythingAnswered,
} as const;
